// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","page":"page-3-UmE","topoWrapper":"topoWrapper-2X7R1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/_landing.css
// module id = 1222
// module chunks = 1